import { isEmpty, isEqual, xorWith } from "lodash";

export const isArrayEqual = <T>(x: T[], y: T[]) =>
	isEmpty(xorWith(x, y, isEqual));
